import { Link, useLocation } from 'react-router-dom';
import './Breadcrumb.css';

function Breadcrumb() {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);
  
  // Don't show breadcrumb on home page
  if (pathnames.length === 0) {
    return null;
  }
  
  // Map URL segments to readable names
  const breadcrumbNameMap = {
    'products': 'Products',
    'case-management': 'Case Management',
    'consultancy': 'Consultancy',
    'support': 'Support',
    'company': 'Company',
    'contact': 'Contact',
    'legal': 'Legal Notices',
    'privacy': 'Privacy Policy'
  };

  return (
    <nav aria-label="Breadcrumb" className="breadcrumb-nav">
      <div className="container">
        <ol className="breadcrumb-list" itemScope itemType="https://schema.org/BreadcrumbList">
          <li className="breadcrumb-item" itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
            <Link to="/" itemProp="item" className="breadcrumb-link">
              <span itemProp="name">Home</span>
            </Link>
            <meta itemProp="position" content="1" />
          </li>
          
          {pathnames.map((name, index) => {
            const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
            const isLast = index === pathnames.length - 1;
            const displayName = breadcrumbNameMap[name] || name.charAt(0).toUpperCase() + name.slice(1);
            
            return (
              <li 
                key={routeTo} 
                className={`breadcrumb-item ${isLast ? 'active' : ''}`}
                itemProp="itemListElement"
                itemScope
                itemType="https://schema.org/ListItem"
              >
                <span className="breadcrumb-separator" aria-hidden="true">/</span>
                {isLast ? (
                  <span itemProp="name" className="breadcrumb-current" aria-current="page">
                    {displayName}
                  </span>
                ) : (
                  <Link to={routeTo} itemProp="item" className="breadcrumb-link">
                    <span itemProp="name">{displayName}</span>
                  </Link>
                )}
                <meta itemProp="position" content={index + 2} />
              </li>
            );
          })}
        </ol>
      </div>
    </nav>
  );
}

export default Breadcrumb;
